import React from 'react';

const PrintContext = React.createContext(null);

export const PrintProvider = PrintContext.Provider;

export default PrintContext;
